const getAccount = state => state.account || {};

const getRep = state => state.rep || {};

const getInspector = state => state.inspector || {};

const getPerson = state => state.person || {};

const getFound = state => state.found;

export default {
  getAccount,
  getRep,
  getInspector,
  getPerson,
  getFound,
};
